import axios from 'axios';

const Employee = {
	namespaced: true,
	actions: {
		CreateEmployee({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}Employee/CreateEmployee`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		UpdateEmployee({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}Employee/UpdateEmployee`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},		
		GetEmployeeAll({ rootState }, { pageNumber,pageSize,searchValue }) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}Employee/GetEmployeeAll?pageNumber=${pageNumber}&pageSize=${pageSize}&searchValue=${searchValue}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},		
	}
}

export default Employee